import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';

const Screen = lazy(() =>
  import('../screens/Config/ConfigScreen').then(m => ({ default: m.ConfigScreen })),
);

export const Route = createFileRoute('/config')({
  component: () => (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <Screen />
    </Suspense>
  ),
});
